<template lang="pug">
.thumbs
  .items
    .heading {{ groups && heading }}
    .item(v-for="group in groups")
      .slides
        .slide(v-for="({ t, th: { url } }, index) in group",
               :title="t",
               :style="{ 'background-image': `url('${ url }')` }")
    //.item(v-for="({ t, th: { url } }, index) in items",
    //  :title="t",
    //  :style="{ 'background-image': `url('${ url }')` }")
      //.slide
</template>
<script>
import { mapGetters } from 'vuex';
import { vuexComputed } from '@/helpers';
export default {
  name: 'feeds',
  props: {
    items: Array,
    heading: {
      type: String,
      default: ''
    }
  },
  computed: {
    ...mapGetters(['customThemes', 'selectedThemes', 'documentsSort', 'skimmerSort', 'themes', 'robo', 'folderLiteCache']),
    ...vuexComputed('folderList', 'folderDoco', 'insightsDoco', 'insightsShown', 'pdf', 'roboWeaveShown', 'notificationsShown', 'backToRobo'),
    groups() {
      const { items } = this;
      return Array.from(new Array(6), (v, i) => group(i));
      function group(offset) {
        return [items[offset], items[offset + 6], items[offset + 12]];
      }
    }
  },
  methods: {
    filteredThemes(topThemes) {
      return topThemes.slice(0, 6);
    }
  } // ,
  //components: { }
};
</script>
<style scoped lang="scss">
@import '../../scss/global';
.thumbs {
  &:hover {
    .items {
      .item {
        -webkit-animation-play-state: initial !important;
        .slides {
          -webkit-animation-play-state: initial !important;
        }
      }
    }
  }
  .items {
    position: relative;
    display: grid;
    grid-template-columns: repeat(3, 3.5rem);
    grid-template-rows: repeat(4, 5.1rem);
    //grid-template-columns: repeat(3, 3rem);
    //grid-template-rows: repeat(4, 4.4rem);
    padding-top: 2rem;
    padding-left: 0.5rem;
    &:hover {
      .heading {
        opacity: 1;
      }
    }
    .heading {
      font-size: 1.5rem;
      font-weight: 200;
      position: absolute;
      top: 0.25rem;
      left: 0.5rem;
      opacity: 0.4;
      -webkit-transition: opacity 250ms ease-in-out;
      transition: opacity 250ms ease-in-out;
      will-change: opacity;
    }
    .item {
      overflow: hidden;
      -webkit-animation-play-state: paused !important;
      .slides {
        -webkit-animation-play-state: paused !important;
      }
      &:nth-child(2) {
        grid-column-end: span 2;
        grid-row-end: span 2;
        .slides {
          grid-template-columns: auto;
          grid-template-rows: repeat(3, 100%);
          animation: vslide 18s reverse infinite;
        }
      }
      &:nth-child(3) {
        grid-column-start: 2;
        grid-row-start: 3;
        grid-column-end: span 2;
        grid-row-end: span 2;
        .slides {
          animation-duration: 9s;
        }
      }
      &:nth-child(4) {
        .slides {
          animation-duration: 27s;
        }
      }
      &:nth-child(5) {
        .slides {
          grid-template-columns: auto;
          grid-template-rows: repeat(3, 100%);
          animation: vslide 15s reverse infinite 5s;
        }
      }
      &:nth-child(6) {
        .slides {
          grid-template-columns: auto;
          grid-template-rows: repeat(3, 100%);
          animation: vslide 12s infinite;
          //animation-duration: 36s;
        }
      }
      .slides {
        height: 100%;
        display: grid;
        grid-template-columns: repeat(3, 100%);
        animation: slide 18s;
        animation-direction: normal;
        animation-iteration-count: infinite;
        .slide {
          background: no-repeat center;
          background-size: contain;
        }
      }
      @keyframes slide {
        0% {
          transform: translate3d(0, 0, 0);
        }
        20% {
          transform: translate3d(0, 0, 0);
        }
        30% {
          transform: translate3d(-100%, 0, 0);
        }
        40% {
          transform: translate3d(-100%, 0, 0);
        }
        50% {
          transform: translate3d(-200%, 0, 0);
        }
        70% {
          transform: translate3d(-200%, 0, 0);
        }
        80% {
          transform: translate3d(-100%, 0, 0);
        }
        90% {
          transform: translate3d(-100%, 0, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }
      @keyframes vslide {
        0% {
          transform: translate3d(0, 0, 0);
        }
        20% {
          transform: translate3d(0, 0, 0);
        }
        30% {
          transform: translate3d(0, -100%, 0);
        }
        40% {
          transform: translate3d(0, -100%, 0);
        }
        50% {
          transform: translate3d(0, -200%, 0);
        }
        70% {
          transform: translate3d(0, -200%, 0);
        }
        80% {
          transform: translate3d(0, -100%, 0);
        }
        90% {
          transform: translate3d(0, -100%, 0);
        }
        100% {
          transform: translate3d(0, 0, 0);
        }
      }
    }
  }
}
</style>
